import {Routes} from '@src/Constant/routes';
import {RouteService} from './RouteService';
import {learnRoutes} from './routes/learnRoutes';
import {listenRoutes} from './routes/listenRoutes';
import {watchRoutes} from './routes/watchRoutes';
import {profileRoutes} from './routes/profileRoutes';
import {publicRoutes} from './routes/publicRoutes';
import {miscRoutes} from './routes/miscRoutes';

const routesConfig = {
  ...learnRoutes,
  ...listenRoutes,
  ...watchRoutes,
  ...profileRoutes,
  ...publicRoutes,
  ...miscRoutes,
};

const routeService = new RouteService();

Object.entries(routesConfig).forEach(([key, route]) => {
  routeService.addRoute(key as Routes, route);
});

export default routeService;
